import { getDetailTransform } from 'helpers/transformResponse';
import type from './types';

const INITIAL_STATE = {
  list: {
    content: [],
  },
  detail: {},
  loading: false,
  buttonLoading: false,
  loadingPagarme: true,
  pagarme: {},
  digitalAccount: {},
  digitalAccountLoading: true,
};

/**
 * @param {Object} state - Default application state
 * @param {Object} action - Action from action creator
 * @returns {Object} New state
 */
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case type.LIST_FETCHED:
      return {
        ...state,
        list: {
          content: action.payload.data.results,
          establishmentData: action.payload.data.establishmentData,
          productActions: action.payload.data.productActions,
        },
        loading: false,
      };
    case type.ITEM_DETAIL:
      return {
        ...state,
        detail: getDetailTransform(action.payload.data) || INITIAL_STATE.detail,
        loading: false,
      };
    case type.PAGARME_FETCHED:
      return {
        ...state,
        pagarme: action.payload,
        loadingPagarme: false,
      };
    case type.PAGARME_LOAD:
      return {
        ...state,
        loadingPagarme: action.payload,
      };
    case type.LIST_LOAD:
      return {
        ...state,
        loading: action.payload,
      };
    case type.BUTTON_LOAD:
      return {
        ...state,
        buttonLoading: action.payload,
      };
    case type.DIGITAL_ACCOUNT_FETCHED:
      return {
        ...state,
        digitalAccount: action.payload,
        digitalAccountLoading: true,
      };
    case type.DIGITAL_ACCOUNT_LOADING:
      return {
        ...state,
        digitalAccountLoading: action.payload,
      };
    default:
      return state;
  }
};
